import { Link } from "react-router-dom";
import { renderStatus } from "../../../../Utils/CommonUtils";
import { useEffect } from "react";
import { useState } from "react";
import SelectDropdownField from "../SelectedOrganization/SelectDropdownField";
import TreeStructureDropdown from "../SelectedOrganization/TreeStructureDropdown";

const useSelectedOrgMappingColumns = () => {

  const orgMappingColumns = [
    {
      header: "Code",
      accessorKey: "code",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Org Relationship",
      accessorKey: "name",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Node",
      accessorKey: "hierarchy_node",
      cell: (props) => (
        <div>
          <TreeStructureDropdown hierarchy_code={props.row.original.hierarchy_code}  getValue={props.getValue} code={props.row.original.code}/>
        </div>
      ),
      size: 200,
    },

    // {
    //   header: "Action",
    //   accessorKey: "linked_status",
    //   cell: (props) =>
    //     props?.getValue() ? renderStatus(props?.getValue()) : "-",
    //   size: 160,
    // },
  ];

  return { orgMappingColumns };
};

export default useSelectedOrgMappingColumns;
